import React from 'react';

import styles from './styles.module.scss';

const CharityEventInfo: React.FC = () => {
    return (
        <div>
            <h2 className={styles.container}>Дитячі мрії</h2>
        </div>
    );
};

export default CharityEventInfo;
